import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card, CardActionArea, CardContent, CardHeader, Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent, FormControl, IconButton, InputLabel, MenuItem, Select,
    Typography
} from "@mui/material";
import { PersonAdd, DeveloperMode, Close, Warning, Edit, EditOutlined } from "@mui/icons-material";
import React, { useContext, useEffect } from "react";
import TabPanel from "../../helpers/TabPanel";
import { CheckBoxItem } from "../../helpers/FormDialog";
import { errorToast, successToast } from "../../helpers/Notification";
import { getError, getSuccessMessage } from "../../store/helpers/common_functions";
import StyledBadge from "../../helpers/StyledBadge";
import { grey } from "@mui/material/colors";
import DeleteDialog from "../../helpers/DeleteDialog";
import GeneralMenu from "../../helpers/GeneralMenu";
import { downloadUrl } from "../../Shared/commonFunction";
import { useHistory } from "react-router-dom";
import SocketContext from "helpers/SocketContext";

function ProgramAssignment({ info, onSuccess, loggedUser, technologies, GetTechnologies, PutAction, FetchDetails }) {


    const { program } = info?.data;

    // const assignType = ["software-developer", "devops", "security", "ui/ux", "tester", "project-manager", "lead-project-manager", "business-analyst", "assigned"]
    const [open, setOpen] = React.useState(false);
    const [value, setValue] = React.useState(2);
    const [selected, setSelected] = React.useState([]);
    const [selectedDev, setSelectedDev] = React.useState([]);
    const [assigning, setAssigning] = React.useState(false);
    const [related, setRelated] = React.useState([]);
    const [developers, setDevelopers] = React.useState([]);
    const [view, setView] = React.useState("all");
    const [id, setId] = React.useState();
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [search, setSearch] = React.useState();
    const [lead, setLead] = React.useState(null);
    const [type, setType] = React.useState(undefined);
    const [positions, setPositions] = React.useState([]);
    const socket = useContext(SocketContext);
    const [assignees, setAssignees] = React.useState([]);

    const history = useHistory();


    const handleOpenNew = () => {
        setOpen(true);
        setValue(0);
    }

    const loadPositions = async () => {
        const resp = await FetchDetails(`/api/staff-position/viewAll`);
        if (resp?.status) {
            const positionList = resp?.data?.list?.map((item) => ({ value: item.id, label: item.name }))
            setPositions([...positionList, { value: null, label: "Unclassified" }]);
        }
    }

    useEffect(() => {
        if (info?.assignees?.length && type) {
            const assignList = info.assignees.filter(v => v.role === type)
            setSelectedDev(assignList.map(v => v.resourceId));
        }
    }, [info, type]);

    const fetchAssignees = async () => {
        const resp = await FetchDetails(`/api/program/assigned-users/${program?.id}`);
        if (resp.status) {
            // setRelated(resp?.data?.data);
            // setDevelopers(resp?.data?.data);
            setAssignees(resp?.data?.data);
        }
    }

    // fetch assignees
    useEffect(() => {
        if (program?.id) {
            fetchAssignees().then();
        }
    }, [program]);

    const assignTech = async () => {
        if (!selected.length) {
            errorToast("Select at least one technology");
            return;
        }

        // setAssigning(true);
        // const resp = await PutAction(`/api/project/assign/technologies/${project.id}`, { technologies: selected });
        // if (resp.status) {
        //     await onSuccess();
        //     await loadRelated();
        //     setValue(2);
        //     successToast(getSuccessMessage(resp));
        // } else {
        //     errorToast(getError(resp));
        // }
        setAssigning(false);
    }

    const assignTeam = async () => {
        if (!selectedDev.length) {
            errorToast("Select at least one team member !");
            return;
        }
        setAssigning(true);
        const resp = await PutAction(`/api/program/assign/team/${program.id}`, { team: selectedDev, type: "assigned" });
        if (resp.status) {
            selectedDev.forEach(async (resourceId) => {
                socket.emit('sendNotification', { 
                    message: `You have been assigned to the program ${program.name}`,
                    resourceId: loggedUser.Resource.id, 
                    receiverId: resourceId,
                    programId: program.id,
                    type: 'program_assigned',
                });
            });

            await onSuccess();
            successToast(getSuccessMessage(resp));
            setOpen(false);
        } else {
            errorToast(getError(resp));
        }
        setAssigning(false);
    }
    const assignTeamLead = async () => {
        if (!lead) {
            errorToast("Select at least one team member to be the lead !");
            return;
        }

        setAssigning(true);
        const resp = await PutAction(`/api/program/assign/lead/${program.id}`, { lead: lead.id });
        if (resp.status) {
            await onSuccess();
            successToast(getSuccessMessage(resp));
            setOpen(false);
        } else {
            errorToast(getError(resp));
        }
        setAssigning(false);
    }

    const loadRelated = async () => {
        // const resp = await FetchDetails(`/api/resource/list/?info=${JSON.stringify({"status":"active","structureId":program?.divisionId})}`);
        const resp = await FetchDetails(`/api/resource/fetch/all/?info=${JSON.stringify({"status":"active"})}`);
        if (resp.status) {
            setDevelopers(resp.data);
        }
    }

    useEffect(() => {
        loadPositions().then();
    }, [])

    useEffect(() => {
        if (value === 2 && !related.length) {
            loadRelated().then();
        }
    }, [value]);

    const initiator = program?.createdBy === loggedUser?.Resource?.id
    const supervisor = assignees?.find(v => v.role === 'supervisor');
    const isSupervisor = supervisor?.Resource?.id === loggedUser?.Resource?.id
    // const canEdit = isSupervisor || initiator || loggedUser?.allowAllProject
    const canEdit = true
    const button = canEdit ? <Button variant={'outlined'} startIcon={<PersonAdd />} onClick={handleOpenNew}>Add New Assignee</Button> : null;

    const viewItems = [
        {
            value: "all",
            label: "All Developers",
        },
        {
            value: "by_tech",
            label: "Filter By Technologies",
        },
    ];

    const selectPositionView = <FormControl fullWidth size={view ? 'small' : 'medium'}>
        <InputLabel id="demo-simple-select-label">Select Position</InputLabel>
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={type}
            label="Select Position"
            onChange={e => {
                const val = e.target.value;
                if (val === "" || val === undefined) {
                    setType(undefined);
                } else {
                    setType(val);
                }
            }}
        >
            <MenuItem value={undefined}>--- All Positions ---</MenuItem>
            {positions?.map(v => <MenuItem key={v.value} value={v.value}>{v.label}</MenuItem>)}
        </Select>
    </FormControl>;

    const viewControl = <div className="grid grid-cols-2 gap-2">
        {selectPositionView}
        <FormControl fullWidth size={view ? 'small' : 'medium'}>
            <InputLabel id="demo-simple-select-label">Select View</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={view}
                label="Select View"
                onChange={e => setView(e.target.value)}
            >
                {viewItems.map(v => <MenuItem key={v.value} value={v.value}>{v.label}</MenuItem>)}
            </Select>
        </FormControl>
    </div>


    const searchView =
        <div className={'grid grid-cols-2 gap-2'}>
            {selectPositionView}
            <div className={'flex'}>
                <input 
                    value={search} 
                    onChange={e => setSearch(e.target.value)} 
                    placeholder={'Search here ...'} 
                    type={'text'} 
                    className={'px-2 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150'} 
                />
            </div>
        </div>;

    const filterFunction = (v) => {
        const lower = search?.toLowerCase();
        const searchCondition = !search || v.names?.toLowerCase()?.includes(lower) || v.category?.toLowerCase()?.includes(lower);
        return searchCondition && (type === v.positionId || type === undefined);
    }

    const teamItem = (resource) => {
        const onClick = () => {
            if (value === 3) {
                setLead(resource);
                return;
            }

            if (selectedDev.filter(v => v === resource.id).length > 0) {
                setSelectedDev(old => old.filter(i => i !== resource.id));
            } else {
                setSelectedDev(old => [...old, resource.id]);
            }
        };

        const isAll = view === 'all';
        let checked = value === 3 ? lead?.id === resource.id : selectedDev.filter(v => v === resource.id).length > 0;

        return <div className={`mr-2 relative ${isAll ? 'mb-3' : ''}`}>
            <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
                <Checkbox onChange={onClick} checked={checked} />
            </div>
            <CardActionArea onClick={onClick}>
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Avatar
                        sx={{ bgcolor: grey[300], width: 60, height: 60 }}
                        alt={resource.names}
                        src={resource.profile ? `${downloadUrl}/${resource.profile}` : undefined}
                    />
                </StyledBadge>
                <div style={{ width: "130px" }}>
                    <Typography sx={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1,
                    }} variant={'body2'}>{resource.names}</Typography>
                    <div>
                        <Typography sx={{
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 1,
                        }} variant={'subtitle2'} style={{ fontWeight: "bold" }}>{resource.category}</Typography>
                    </div>
                </div>
            </CardActionArea>
        </div>
    }

    return <div>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth={'md'} fullWidth={true}>
            <DialogContent>
                <Box sx={{ width: '100%' }} className={'bg-white'}>
                    <TabPanel value={value} index={0} className={''}>
                        <div className={'flex flex-col text-center justify-between'} style={{ minHeight: "70vh" }}>
                            <div className={'text-center'}>
                                <div className={'justify-center'}>
                                    <Typography variant={'h4'}>Assign User(s)</Typography>
                                </div>
                            </div>
                            <div className="flex flex-col justify-between" style={{ minHeight: "60vh" }}>
                            <div>
                                {!view ? viewControl : view === 'all' ? <div>
                                    <div className={'mb-5'}>
                                        {searchView}
                                    </div>
                                    <div className={'flex flex-wrap'}>
                                        {developers?.filter(filterFunction).map(v => teamItem(v))}
                                    </div>
                                </div> : <div>
                                    {searchView}
                                    {related && related.map(v => {
                                        // const filter = v.Technology.ResourceTechnologies.map(v => v.Resource).filter(filterFunction);
                                        const filter = v;
                                        return <div key={v.id}>
                                            {/* <div className={'text-left'}><Typography variant={'h6'}>{v.Technology.name}</Typography></div> */}
                                            <div className={'mt-3 mb-3'}>
                                                <Card>
                                                    <div>
                                                        {filter.length ? <div style={{ overflowX: 'auto' }} className={'flex p-3'}>
                                                            {filter.map(resource => teamItem(resource))}
                                                        </div> : <div className={'p-5'}>
                                                            <Warning style={{ fontSize: "40px" }} />
                                                            <div>No Team members found !</div>
                                                        </div>}
                                                    </div>
                                                </Card>
                                            </div>
                                        </div>;
                                    })}
                                </div>}
                            </div>
                            <div>
                                {assigning ? <CircularProgress /> : <>
                                    <div><Button 
                                        variant={'outlined'}
                                        onClick={assignTeam}
                                    >Assign Team</Button></div>
                                    <div><Button color={'error'} onClick={() => setOpen(false)}>Close</Button></div>
                                </>}
                            </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={1} className={''}>
                        <div className={'flex flex-col text-center justify-between'} style={{ minHeight: "70vh" }}>
                            <div>
                                <Typography variant={'h4'}>Assign Project Technologies</Typography>
                            </div>
                            <div>
                                <CheckBoxItem item={{ value: selected, setValue: setSelected, values: technologies.map(v => ({ label: v.name, value: v.id })) }} />
                            </div>
                            <div>
                                {assigning ? <CircularProgress /> : <>
                                    <div><Button onClick={assignTech} variant={'contained'}>Add Technologies</Button></div>
                                    <div><Button onClick={() => setValue(0)}>Back</Button></div>
                                </>
                                }
                            </div>
                        </div>
                    </TabPanel>


                    <TabPanel value={value} index={2} className={''}>
                        <div className={'flex flex-col text-center justify-between'} style={{ minHeight: "70vh" }}>
                            <div className={'text-center'}>
                                <div className={'justify-center'}>
                                    <Typography variant={'h4'}>Project Technologies</Typography>
                                </div>
                                {info?.technologies?.map(v => <Chip className={'ml-2'} label={v.Technology?.name} />)} <a className={'underline text-blue-600'} onClick={e => {
                                    e.preventDefault();
                                    setValue(1);
                                }}
                                    href="#">Edit ...</a>
                            </div>
                            <div>
                                {!view ? viewControl : view === 'all' ? <div>
                                    <div className={'mb-5'}>
                                        {searchView}
                                    </div>
                                    <div className={'flex flex-wrap'}>
                                        {developers.filter(filterFunction).map(v => teamItem(v))}
                                    </div>

                                </div> : <div>
                                    {searchView}
                                    {related && related.map(v => {
                                        const filter = v.Technology.ResourceTechnologies.map(v => v.Resource).filter(filterFunction);
                                        return <div>
                                            <div className={'text-left'}><Typography variant={'h6'}>{v.Technology.name}</Typography></div>
                                            <div className={'mt-3 mb-3'}>
                                                <Card>
                                                    <div>
                                                        {filter.length ? <div style={{ overflowX: 'auto' }} className={'flex p-3'}>
                                                            {filter.map(resource => {
                                                                return teamItem(resource);
                                                            })}
                                                        </div> : <div className={'p-5'}>
                                                            <Warning style={{ fontSize: "40px" }} />
                                                            <div>No Team members found !</div>
                                                        </div>}
                                                    </div>
                                                </Card>
                                            </div>
                                        </div>;
                                    })}
                                </div>}
                            </div>
                            <div>
                                {assigning ? <CircularProgress /> : <>
                                    <div><Button onClick={assignTeam} variant={'outlined'}>Assign Team</Button></div>
                                    <div><Button color={'error'} onClick={() => setOpen(false)}>Close</Button></div>
                                </>
                                }
                            </div>
                        </div>
                    </TabPanel>

                    <TabPanel value={value} index={3} className={''}>
                        <div className={'flex flex-col text-center '} style={{ minHeight: "70vh" }}>
                            <div className={'text-center'}>
                                <div className={'justify-center'}>
                                    <Typography variant={'h4'}>Assign Team lead</Typography>
                                </div>
                            </div>
                            <div className="flex flex-col justify-between " style={{ minHeight: "60vh" }}>
                            <div className="mt-5">
                                {<div>
                                    <div className={'mb-5'}>
                                        {searchView}
                                    </div>
                                    <div className={'flex flex-wrap'}>
                                        {assignees?.filter(filterFunction)?.map(v => teamItem(v.Resource))}
                                    </div>

                                </div>}
                            </div>
                            <div>
                                {assigning ? <CircularProgress /> : <>
                                    <div><Button onClick={assignTeamLead} variant={'outlined'}>Assign Team Lead</Button></div>
                                    <div><Button color={'error'} onClick={() => setOpen(false)}>Close</Button></div>
                                </>
                                }
                            </div>
                            </div>
                        </div>
                    </TabPanel>
                </Box>
            </DialogContent>
        </Dialog>
        <DeleteDialog 
            open={deleteOpen} 
            setOpen={() => setDeleteOpen(false)} 
            onSuccess={onSuccess} 
            url={`/api/program/delete/team/member/${program?.id}/${id}`} 
        />
        {assignees?.length ? <div>
            <div className={'mb-3'}>{button}</div>
            <div className={'mb-3 text-center'}><Typography variant={'h5'}>Team Lead</Typography></div>
            {!supervisor ? <div className={'p-8 text-center'}>
                <Typography>No Team Lead assigned Yet</Typography>
                <div>
                    {canEdit && <Button onClick={() => {
                        setValue(3);
                        setOpen(true);
                    }} startIcon={<PersonAdd />}>Add Team Lead</Button>}
                </div>
            </div> : <div className={'flex justify-center'}>
                <div className={'text-center relative'}>
                    <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
                        {canEdit && <IconButton onClick={() => {
                            setOpen(true);
                            setValue(3);
                            setLead(supervisor.Resource);
                        }} color={'primary'}><Edit /></IconButton>}
                    </div>
                    <CardActionArea disabled={!supervisor} onClick={supervisor ? () => {
                        history.push(`/admin/profile/${supervisor?.Resource.id}`);
                    } : undefined}>
                        <StyledBadge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        >
                            <Avatar
                                sx={{ bgcolor: grey[300], width: 110, height: 110 }}
                                alt={supervisor.Resource.names}
                                src={supervisor.Resource.profile ? `${downloadUrl}/${supervisor.Resource.profile}` : undefined}
                            />
                        </StyledBadge>
                        <div style={{ width: "130px" }}>
                            <Typography sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 1,
                            }} variant={'body2'}>{supervisor.Resource.names}</Typography>
                            <div>
                                <Typography sx={{
                                    display: '-webkit-box',
                                    overflow: 'hidden',
                                    WebkitBoxOrient: 'vertical',
                                    WebkitLineClamp: 1,
                                }} variant={'subtitle2'} style={{ fontWeight: "bold" }}>{supervisor.Resource?.StaffPosition?.name}</Typography>
                            </div>
                        </div>
                    </CardActionArea>
                </div>
            </div>}
            <div className={'mb-3'}><Typography variant={'h5'}>Assignee(s) ({assignees.length})</Typography></div>
            <div className="grid grid-cols-3 gap-4">
                {positions && positions?.map(item => {
                    const assignList = assignees?.filter((assign) => assign.Resource?.positionId === item.value)
                    return assignList?.length ? <Card key={item.value} className={'mb-3'}>
                        <CardHeader 
                            subheader={item?.label} 
                            action={canEdit ? <IconButton onClick={() => {
                                setValue(3);
                                setOpen(true);
                            }}><EditOutlined /></IconButton> : null} 
                        />
                        <CardContent sx={{ padding: 0 }}>
                            <div className={'flex flex-wrap mb-5'}>
                                {assignList?.map(v => <div key={v.id} className={'md:w-6/12 lg:w-6/12 w-full px-4'}>
                                    <div className={'mr-2 relative text-center'}>
                                        <div className={'absolute right-0'} style={{ zIndex: "10", top: "-10px" }}>
                                            {canEdit && <IconButton onClick={() => {
                                                setId(v.id);
                                                setDeleteOpen(true);
                                            }} color={'error'}><Close /></IconButton>}
                                        </div>
                                        <CardActionArea 
                                            sx={{ padding: "5px" }} 
                                            disabled={!loggedUser?.allowResource} 
                                            onClick={loggedUser?.allowResource ? () => {
                                                history.push(`/admin/profile/${v.Resource.id}`);
                                            } : undefined}
                                        >
                                            <div style={{ width: "130px" }}>
                                                <StyledBadge
                                                    overlap="circular"
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                >
                                                    <Avatar
                                                        sx={{ bgcolor: grey[300], width: 60, height: 60 }}
                                                        alt={v.Resource.names}
                                                        src={v.Resource.profile ? `${downloadUrl}/${v.Resource.profile}` : undefined}
                                                    />
                                                </StyledBadge>
                                                <Typography sx={{
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 1,
                                                }} variant={'body2'} className={'mt-2'}>{v.Resource.names}</Typography>
                                                <Typography sx={{
                                                    display: '-webkit-box',
                                                    overflow: 'hidden',
                                                    WebkitBoxOrient: 'vertical',
                                                    WebkitLineClamp: 1,
                                                }} variant={'subtitle2'} style={{ fontWeight: 'bold' }}>{v.Resource.StaffPosition?.name}</Typography>
                                            </div>
                                        </CardActionArea>
                                    </div>
                                </div>)}
                            </div>
                        </CardContent>
                    </Card> : null
                })}
            </div>
        </div> : <div className={'flex justify-center items-center'} style={{ height: "70vh" }}>
            <div className={'text-center'}>
                <div className={'mb-3'}>
                    {button}
                </div>
                <div className={'mb-3'}>
                    <Typography variant={'h6'}>No Assignees added yet, Add one</Typography>
                </div>
            </div>
        </div>}
    </div>;
}



export default connect(mapStateToProps, mapDispatchToProps)(ProgramAssignment);
